<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <!-- <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <template>
              <a-col :md="6" :sm="24">
                <a-form-item label="省">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.province" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template>
              <a-col :md="6" :sm="24">
                <a-form-item label="市">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.city" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template>
              <a-col :md="6" :sm="24">
                <a-form-item label="区">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.area" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="时间范围">
                  <a-range-picker
                    v-model="value"
                    format="YYYY-MM-DD"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onChange"
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div> -->
      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <a-button
            :loading="loadingAdd"
            type="primary"
            @click="$refs.createForm.handleAdd()"
            v-hasPermi="['upkeep:point:add']"
          >
            <a-icon type="plus" />新增
          </a-button>
          <a-button
            type="primary"
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['upkeep:point:edit']"
          >
            <a-icon type="edit" />修改
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['upkeep:point:remove']">
            <a-icon type="delete" />删除
          </a-button>
          <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['abm-fix:dev:export']">
          <a-icon type="download" />导出
        </a-button> -->
        </template>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :userList="userList"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
        @close="loadingAdd = false"
      />
      <!-- 详情 -->
      <reginDetail ref="reginDetail"></reginDetail>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
      >
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <span slot="tenantCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:jing:three')">
          <a-button type="link" size="large">
            {{ record.tenantCount }}
          </a-button>
        </span>
        <span slot="devCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:she:three')">
          <a-button type="link" size="large">
            {{ record.devCount }}
          </a-button>
        </span>
        <span slot="examinerCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:she:three')">
          <a-button type="link" size="large">
            {{ record.examinerCount }}
          </a-button>
        </span>
        <span slot="waterCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:she:three')">
          <a-button type="link" size="large">
            {{ record.waterCount }}
          </a-button>
        </span>
        <span slot="orderCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:ding:three')">
          <a-button type="link" size="large">
            {{ record.orderCount }}
          </a-button>
        </span>
        <span slot="address" slot-scope="text, record">
          <a-tooltip :title="`${record.province} ${record.city} ${record.area} ${record.address}`">
            <!-- <span class="ellipsis-text">{{ text }}</span> -->
            {{ record.province }} {{ record.city }} {{ record.area }} {{ record.address }}
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['upkeep:point:edit']"> 修改 </a>
          <a-divider type="vertical" v-hasPermi="['upkeep:point:remove']" />
          <a-dropdown v-hasPermi="['upkeep:point:remove', 'upkeep:point:query']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['system:tenant:query']">
                <a v-hasPermi="['system:region:query']" @click="$refs.reginDetail.init(record, 1)"> 详情 </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>
<script>
import { fetchList, delObj } from '@/api/repairModule/repairArea'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'
import reginDetail from './modules/reginDetail.vue'
export default {
  name: 'Post',
  components: {
    CreateForm,
    reginDetail,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      loadingAdd: false,
      selectedRowKeys: [],
      selectedRows: [],
      value: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      userList: [],
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      },
      columns: [
        // {
        //   title: '区域名称',
        //   dataIndex: 'name',
        //   width: 100,
        //   align: 'center',
        //   fixed: 'left',
        // },
        // {
        //   title: '联系电话',
        //   dataIndex: 'mobile',
        //   width: 120,
        //   align: 'center',
        // },
        // {
        //   title: '联系人',
        //   dataIndex: 'contacts',
        //   ellipsis: true,
        //   width: 80,
        //   align: 'center',
        // },
        // {
        //   title: '企业品牌',
        //   dataIndex: 'tenantName',
        //   ellipsis: true,
        //   width: 100,
        //   align: 'center',
        // },
        // {
        //   title: '经销商',
        //   dataIndex: 'tenantCount',
        //   width: 70,
        //   scopedSlots: { customRender: 'tenantCount' },
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '设备',
        //   dataIndex: 'devCount',
        //   width: 70,
        //   scopedSlots: { customRender: 'devCount' },
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '验收员',
        //   dataIndex: 'examinerCount',
        //   width: 80,
        //   scopedSlots: { customRender: 'examinerCount' },
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '水工',
        //   dataIndex: 'waterCount',
        //   width: 70,
        //   scopedSlots: { customRender: 'waterCount' },
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '订单	',
        //   dataIndex: 'orderCount',
        //   width: 60,
        //   scopedSlots: { customRender: 'orderCount' },
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '省',
          dataIndex: 'province',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '市',
          dataIndex: 'province',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '区',
          dataIndex: 'province',
          ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '详细地址',
        //   dataIndex: 'address',
        //   scopedSlots: { customRender: 'address' },
        //   ellipsis: true,
        //   width: 120,
        //   align: 'center',
        // },
        // {
        //   title: '设备编号',
        //   dataIndex: 'devCode',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '租户简称',
        //   dataIndex: 'referredName',
        //   align: 'center',
        // },
        // {
        //   title: '租户编码',
        //   dataIndex: 'code',
        //   align: 'center',
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          width: 180,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 130,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    if (!this.isOperate) {
      this.columns.pop()
    }

    this.queryParam.tenantId = this.tenantId
    this.getList()
  },
  computed: {
    hasPermission() {
      return (permission) => {
        console.log(this.userType, '测试type====')
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {

    // 点击展示不同的页面信息
    handleLook(e, index, name) {
      if (!this.hasPermission(name)) return this.$message.error('暂无权限查看')
      this.$nextTick(() => {
        this.$refs.reginDetail.init(e, index)
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
      this.queryParam.createBeginTime = moment(e[0]).format('YYYY-MM-DD')
      this.queryParam.createEndTime = moment(e[1]).format('YYYY-MM-DD')
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
      this.loadingAdd = false
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
